module.exports = __webpack_public_path__ + "img/right.2565798f.png";